import slugify from 'slugify';

/**
 * Generate a subdomain from a brand name.
 * Matches the backend logic in BrandController.ts.
 *
 * Rules:
 * - Lowercase, alphanumeric and hyphens only
 * - Minimum 3 characters (padded with 'x' if needed)
 * - Maximum 50 characters (truncated if needed)
 * - No trailing hyphens
 *
 * @param {string} brandName - The brand name to generate a subdomain from
 * @returns {string} The generated subdomain
 */
export function generateSubdomain(brandName) {
  if (!brandName || typeof brandName !== 'string') {
    return '';
  }

  // Slugify the brand name: lowercase, remove special chars, trim
  let subdomain = slugify(brandName, { lower: true, strict: true, trim: true });

  // If empty after slugification, return empty
  if (!subdomain) {
    return '';
  }

  // Ensure minimum length of 3 characters
  if (subdomain.length < 3) {
    subdomain = subdomain.padEnd(3, 'x');
  }

  // Ensure maximum length of 50 characters
  if (subdomain.length > 50) {
    subdomain = subdomain.substring(0, 50);
  }

  // Remove trailing hyphens
  subdomain = subdomain.replace(/-+$/, '');

  return subdomain;
}

export default generateSubdomain;
